module.exports = __webpack_public_path__ + "img/17.0f0d26c0.png";